import SelectField from '../../../components/Forms/Input/SelectField';
import {
  mapInventorySettings,
  toInventoryUpdateDTO,
} from './RestaurantSettingsMapper';
import RestaurantSettingsFormLayout from './RestaurantSettingsFormLayout';
import RestaurantSettingsToggle from './RestaurantSettingsToggle';
import RestaurantFormHelp from '../shared/RestaurantFormHelp';
import { InventoryConsumptionMoment } from './RestaurantSettingsTypes';
import useRestaurantSettingsForm from './useRestaurantSettingsForm';

interface Props {
  branchId: number;
}

const consumptionMomentOptions = [
  { value: 'WHEN_PREPARING', label: 'Al iniciar la preparación' },
  { value: 'WHEN_READY', label: 'Al finalizar la preparación' },
  { value: 'WHEN_BILLED', label: 'Al facturar la orden' },
];

const RestaurantInventorySettingsForm = ({ branchId }: Props) => {
  const settings = useRestaurantSettingsForm(
    branchId,
    'inventory',
    mapInventorySettings,
    toInventoryUpdateDTO
  );
  const { form, updateField } = settings;

  return (
    <RestaurantSettingsFormLayout
      title="Inventario"
      description="Define cómo y cuándo se descuentan los insumos de cada preparación."
      loading={settings.loading}
      saving={settings.saving}
      hasData={Boolean(form)}
      alert={settings.alert}
      onCloseAlert={() => settings.setAlert(null)}
      onSave={settings.save}
      onRetry={settings.reload}
      help={<RestaurantFormHelp topic="settingsInventory" variant="inline" />}
    >
      {form && (
        <>
          <RestaurantSettingsToggle
            label="Módulo de inventario activo"
            description="Habilita las reglas de inventario de restaurante para esta sucursal."
            name="inventory-active"
            checked={form.active}
            onChange={() => updateField('active', !form.active)}
          />
          <SelectField
            label="Momento del consumo"
            iconKey="clock"
            name="inventoryConsumptionMoment"
            value={form.inventoryConsumptionMoment}
            options={consumptionMomentOptions}
            onChange={(event) =>
              updateField(
                'inventoryConsumptionMoment',
                event.target.value as InventoryConsumptionMoment
              )
            }
          />
          <p className="-mt-3 text-xs text-bodydark2">
            Preparación descuenta al iniciar cocina; finalización, al marcar listo; facturación, al cobrar la orden.
          </p>
          <RestaurantSettingsToggle
            label="Consumo automático"
            description="Descuenta automáticamente los insumos de las recetas."
            name="inventory-consumption"
            checked={form.inventoryConsumptionEnabled}
            onChange={() =>
              updateField(
                'inventoryConsumptionEnabled',
                !form.inventoryConsumptionEnabled
              )
            }
          />
          <RestaurantSettingsToggle
            label="Permitir inventario negativo"
            description="Permite preparar aunque el inventario quede por debajo de cero."
            name="allow-negative-stock"
            checked={form.allowNegativeStock}
            onChange={() =>
              updateField('allowNegativeStock', !form.allowNegativeStock)
            }
          />
          <RestaurantSettingsToggle
            label="Validar existencia antes de preparar"
            description="Verifica la disponibilidad de insumos antes de iniciar cocina."
            name="validate-stock-before-preparation"
            checked={form.validateStockBeforePreparation}
            onChange={() =>
              updateField(
                'validateStockBeforePreparation',
                !form.validateStockBeforePreparation
              )
            }
          />
        </>
      )}
    </RestaurantSettingsFormLayout>
  );
};

export default RestaurantInventorySettingsForm;
